import { getMessage } from "intus/lib";

export default () => {
    return function isArrayNoEmptyValue({value, attribute, messages}) {
      return {
        passes() {
          return !value.some(item => !item?.trim());
        },
        message(msg = ":attribute other value cannot be empty.") {
            return msg.replaceAll(":attribute", getMessage(attribute, messages));
        },
      };
    };
  }
